import { useState, useEffect } from "react";

const ProfilePage = ({ viewportHeight }) => {
	const [containerClass, setContainerClass] = useState("");
	const [titleClass, setTitleClass] = useState("");
	const [barCodeClass, setBarCodeClass] = useState("");
	const [codeClass, setCodeClass] = useState("");
	const [errorClass, setErrorClass] = useState("");
	const [tryLaterClass, setTryLaterClass] = useState("");
	const [code, setCode] = useState({
		ready: false,
		value: "",
	});
	const [info, setInfo] = useState({
		ready: false,
		data: {},
	});

	useEffect(() => {
		window.addEventListener("resize", handleResize);
		handleResize();
		setCode({
			ready: true,
			value: "127308213",
		});

		setInfo({
			ready: false,
			data: {
				name: "Tory Burch",
				birthday: "1 Jan 2000",
				phone: "545 652 4044",
				email: "email@toryburch.com",
			},
		});

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);

	const handleResize = () => {
		if (window.innerWidth > 640) {
			setContainerClass("px-[112px] flex flex-col items-center");
			setTitleClass("w-[169px]");
			setBarCodeClass("w-[416px] h-auto mt-2");
			setCodeClass(
				"text-[19px] bai-jamjuree-semibold tracking-[5px] leading-4",
			);
			setErrorClass("w-[292px] h-auto mt-[160px]");
			setTryLaterClass("w-[366px] h-auto mt-[160px]");
		} else {
			setContainerClass("px-[7.5vw] flex flex-col h-full items-center");
			setTitleClass("w-[26vw]");
			setBarCodeClass("w-[65vw] h-auto mt-2");
			setErrorClass("w-[46vw] h-auto mt-[40vw]");
			setTryLaterClass("w-[57vw] h-auto mt-[40vw]");
			if (window.innerWidth > 460 && window.innerWidth <= 640) {
				setCodeClass(
					"text-[19px] bai-jamjuree-semibold tracking-[5px] leading-4",
				);
			} else if (window.innerWidth > 390 && window.innerWidth <= 460) {
				setCodeClass(
					"text-[14px] bai-jamjuree-semibold tracking-[4px] leading-4",
				);
			} else {
				setCodeClass(
					"text-[13px] bai-jamjuree-semibold tracking-[3px] leading-4",
				);
			}
		}
	};

	return (
		<div
			className={containerClass}
			style={{
				height: viewportHeight,
			}}
		>
			{code.ready && (
				<div className="flex flex-col items-center">
					<img
						alt={"title"}
						className={titleClass}
						src={window.assetUrl(
							"/images/liff/profile-page/title.png",
						)}
					/>
					<img
						alt={"barcode"}
						className={barCodeClass}
						src={window.assetUrl(
							"/images/liff/profile-page/barcode.png",
						)}
					/>
					<p className={codeClass}>{code.value}</p>
				</div>
			)}
			{!info.ready && (
				<div className={"flex grow flex-col items-center justify-between"}>
					<img
						alt={"loading"}
						className={errorClass}
						src={window.assetUrl(
							"/images/liff/profile-page/error.png",
						)}
						style={{
							marginTop: code.ready ? "" : "",
						}}
					/>
					<img
						alt={"reload"}
						className={tryLaterClass}
						src={window.assetUrl(
							"/images/liff/profile-page/try-later.png",
						)}
						style={{
							marginTop: code.ready ? "" : "",
						}}
					/>
				</div>
			)}
		</div>
	);
};

export default ProfilePage;
